import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface AuthState {
  liffId: string;
  logSessionToken: string;
}

interface RootState {
  auth: AuthState;
}

const initialState: AuthState = {
  liffId: '',
  logSessionToken: '',
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    liffIdInit: (state, action: PayloadAction<string>) => ({
      ...state,
      liffId: action.payload,
    }),
    logSessionTokenInit: (state, action: PayloadAction<string>) => ({
      ...state,
      logSessionToken: action.payload,
    }),
  },
});

export default authSlice.reducer;

// actions
export const { liffIdInit: authLiffIdInit, logSessionTokenInit: authLogSessionTokenInit } =
  authSlice.actions;

// selectors
export const selectLiffId = (state: RootState) => state.auth.liffId;

export const selectLogSessionToken = (state: RootState) => state.auth.logSessionToken;
